<template>
  <div class="BaseTemplateContentShape flex" @click="templateStore.handleActiveItem(item)">
    <div
      class="BaseTemplateContentShape__shape"
      :class="[`BaseTemplateContentShape--${item.value}`]"
      :style="[
        `width: ${item.width}px; `,
        item.value === 'line'
          ? ` border-bottom: ${item.height}px ${item.variant} ${item.colour};`
          : ` height: ${item.height}px; background-color: ${item.colour};`,
      ]"
    ></div>
  </div>
</template>

<script setup>
import { useTemplateStore } from 'src/stores'

defineOptions({ name: 'BaseTemplateContentShape' })
defineProps({ item: { type: Object, required: true } })

const templateStore = useTemplateStore()
</script>

<style lang="sass" scoped>
@import "src/shared/styles/mixins.sass"

.BaseTemplateContentShape
  // Only colours animate: animating width/height makes resizing lag behind the cursor
  @include element('shape')
    transition: background-color 0.3s ease, border-color 0.3s ease
  @include state-modifier('star')
    clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)
  @include state-modifier('circle')
    clip-path: circle(50% at 50% 50%)
</style>
